// extracted by mini-css-extract-plugin
export default {"Date":"StartTimeInfo_Date__ljB7F"};